/* people-watching.js  –– Bug Zoo “viewers” snippet  */
(function () {
  // pick a new random number every time the page loads
  const viewers = Math.floor(Math.random() * 46) + 5; // 5 – 50
  // find the span we’ll create in step 2
  const target = document.querySelector('[data-viewers-count]');
  if (target) target.textContent = viewers;
})();
